import dynamic from 'next/dynamic';
const PartnerSignupComponent = dynamic(() => import('@/components/landing/home/PartnerSignup'));
const LandingLayout = dynamic(() => import('@/components/landing/home/LandingLayout'), { ssr: false });

const PartnerSignup = () => {
  return (
    <LandingLayout>
      <div className="">
        <PartnerSignupComponent />
      </div>
    </LandingLayout>
  );
};

export default PartnerSignup;
